/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */ 
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes  } from 'mobx-react';
import { isStateTreeNode, isAlive } from 'mobx-state-tree';

function objectIsValid(model, required, props, propName, componentName) {
	const o = props[propName];
	if(typeof o === 'undefined') {
		if(required) {
			return new Error(`The prop \`${propName}\` is marked as required in \`${componentName}\`, but its value is \`undefined\`.`);
		} else {
			return;
		}
	}
	if(!isStateTreeNode(o)) {
		return new Error(`Invalid prop \`${propName}\` of type \`${typeof o}\` supplied to \`${componentName}\`, expected MobX state tree model of type \`${model.name}\``);
	}
	if(!isAlive(o)) {
		return new Error(`Invalid prop \`${propName}\` supplied to \`${componentName}\`: expected MobX state tree model is not alive (it is obsolete)`);
	}
	if(!model.is(o)) {
		const actualType = o.$treenode && o.$treenode.type && o.$treenode.type.name;
		const typeDesc = actualType ?
			`MobX state tree model \`${actualType}\`` :
			'unknown MobX state tree model';
		return new Error(`Invalid prop \`${propName}\` of ${typeDesc} supplied to \`${componentName}\`, expected MobX state tree model of type \`${model.name}\``);
	}
}

export default {
	stateTree: (model) => {
		const optional = (props, propName, componentName) => {
			return objectIsValid(model, false, props, propName, componentName);
		};
		optional.isRequired = (props, propName, componentName) => {
			return objectIsValid(model, true, props, propName, componentName);
		};
		return optional;
	},
	...PropTypes,
	...MobxPropTypes
};



// WEBPACK FOOTER //
// ./src/js/util/PropTypes.js